<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg', body: { base: 'overflow-visible' } }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">Create Feedback Report</h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div class="space-y-4">
                <UFormGroup label="Notes">
                    <UTextarea v-model="data.notes" size="xl" />
                </UFormGroup>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white"> Cancel </UButton>
                    <UButton @click="confirm()" size="lg" color="black"> Save </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import { FEEDBACK_REPORT_REASON_ID, type Call } from '~/types/call';

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [void]
}>()

const props = defineProps<{
    open: boolean
    call?: Call
}>()

const client = useSupabaseClient()
const toast = useToast()

const auth = useAuthStore()

const confirming = ref<boolean>(false)

const data = reactive({
    notes: '',
})

watch(() => props.open, (open) => {
    if (open) {
        confirming.value = false
        data.notes = ''
    }
})

async function confirm() {
    if (props.call?.id) {
        confirming.value = true

        const { error } = await client.from('call_reports')
            .insert({
                call_id: props.call.id,
                customer_id: props.call.customer.id,
                user_id: auth.user?.id,
                call_reason_id: FEEDBACK_REPORT_REASON_ID,
                notes: data.notes,
                updated_at: new Date().toISOString()
            } as never)

        if (!error) {
            toast.add({
                title: 'Feedback report created!',
                color: 'green',
                icon: 'i-ph-check-circle-duotone'
            })

            emit('reload')
            dismiss()
        }
    }
}

function dismiss() {
    emit('update:open', false)
}
</script>
